import { render, staticRenderFns } from "./AccountTypesChips.vue?vue&type=template&id=25d65f6c"
import script from "./AccountTypesChips.vue?vue&type=script&lang=js"
export * from "./AccountTypesChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports